package com.example.readingnotes.data.remote.api

object ApiRoutes {
    // Auth routes
    const val AUTH_LOGIN = "/api/auth/login"
    const val AUTH_LOGOUT = "/api/auth/logout"
    const val AUTH_ME = "/api/auth/me"
    const val AUTH_REGISTER = "/api/auth/register"
    const val AUTH_LOGIN_USERNAME = "/api/auth/login-username"
    const val AUTH_VERIFY_TOTP = "/api/auth/verify-totp"
    const val AUTH_SETUP_TOTP = "/api/auth/setup-totp"
    const val AUTH_USERNAME = "/api/auth/username"
    const val AUTH_SEND_VERIFICATION_CODE = "/api/auth/send-verification-code"
    const val AUTH_VERIFY_EMAIL = "/api/auth/verify-email"
    const val AUTH_LOGIN_WITH_CODE = "/api/auth/login-with-code"

    fun checkUsername(username: String) = "/api/auth/check-username/$username"

    // Post routes
    const val POSTS = "/api/posts"

    fun post(id: Int) = "/api/posts/$id"

    fun postStatus(id: Int) = "/api/posts/$id/status"

    // Comment routes
    fun comments(postId: Int) = "/api/posts/$postId/comments"

    fun comment(id: Int) = "/api/comments/$id"

    const val COMMENTS_BULK_DELETE = "/api/comments/bulk-delete"

    // Audit routes
    const val AUDIT_LOGS = "/api/audit-logs"

    // Image routes
    const val IMAGES_UPLOAD_URL = "/api/images/upload-url"
    const val IMAGES_CONFIRM = "/api/images/confirm"
    const val IMAGES = "/api/images"
    const val IMAGES_EDIT = "/api/images/edit"

    fun image(id: Int) = "/api/images/$id"

    // Tag routes
    const val TAGS = "/api/tags"

    fun tag(id: Int) = "/api/tags/$id"

    fun tagsForPost(postId: Int) = "/api/posts/$postId/tags"

    fun addTagToPost(postId: Int, tagId: Int) = "/api/posts/$postId/tags/$tagId"

    const val TAGS_POPULAR = "/api/tags/popular"

    const val TAGS_SEARCH = "/api/tags/search"

    // Search routes
    const val SEARCH = "/api/search"

    // Push notification routes
    const val PUSH_SETTINGS = "/api/push/settings"
    const val PUSH_NOTIFICATIONS = "/api/push/notifications"
    const val PUSH_NOTIFICATIONS_READ_ALL = "/api/push/notifications/read-all"

    fun pushNotification(id: Int) = "/api/push/notifications/$id/read"
}
